import * as React from 'react';
import type { SidebarContextValue } from './types/sidebar-provider-variants-types';

export const SidebarContext = React.createContext<SidebarContextValue | null>(null);
